module.exports = __webpack_public_path__ + "static/media/bet-type.445b3f63.svg";